export const moduleConfig = {
    entityKey: 'payment-events',
    titles: {
        singular: 'Payment event',
        plural: 'Payment events',
    },
};
